<template>
  <div>
    <vs-input
        v-validate="'required|email'"
        data-vv-validate-on="blur"
        name="username"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="E-mail"
        v-model="username"
        class="w-full"/>
    <span class="text-danger text-sm" v-show="errors.has('username')">{{$t("email_error")}}</span>

    
    <div class=" flex flex-wrap-wrap items-center data-list-btn-container">
    <div class="flex flex-wrap-wrap items-center data-list-btn-container relative w-full mb-6" >

    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required'"
        :type="showPassword ? 'text' : 'password'"
        name="password"
        :icon="showPassword ? 'icon icon-unlock' : 'icon icon-lock'"
        icon-no-border
        icon-pack="feather"
        :label-placeholder="$t('Mot_de_passe')"
        v-model="password"
        class="w-full mt-6" />
    </div>
    <div class="btn-add-new p-2  ml-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
            <feather-icon @click="showPassword = !showPassword" :icon="showPassword ? 'EyeIcon' : 'EyeOffIcon'" svgClasses="h-4 w-4" />
    </div>
    
    <span class="text-danger text-sm" v-show="errors.has('password')">{{$t("password_error")}}</span>
  
    </div>
    <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">{{ $t("Se_souvenir_de_moi") }}</vs-checkbox>
        
        <router-link to="/forgot-password">{{ $t("Mot_de_passe_oublié") }}</router-link>
       
    </div>
    <div class="flex flex-wrap justify-center mb-3">


    <vs-button class="mr-20"  :disabled="!validateForm" @click="loginJWT">{{ $t("Connexion") }}</vs-button>

   
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
const localStorageKey = 'loggedIn'
const tokenExpiryKey = 'tokenExpiry'
const dict = {
  custom: {
    email: {
      required: 'Le champ email est obligatoire'
    },
    password: {
      required: 'Le champ mot de passe est obligatoire'
    }
  }
}
Validator.localize('fr', dict)
export default {
  data () {
    return {
      username: '',
      password: '',
      showPassword: false,
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.username !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginJWT () {
      // const lang = window.getlanguage.$i18n.locale
      if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const data = {
        username: this.username,
        password: this.password
        // lg: lang
      }
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: 'admin@admin.com',
          password: 'adminadmin',
          data
        }
      }
      this.$store.dispatch('auth/loginJWT', payload)
        .then(() => { this.$vs.loading.close() })
        .catch(error => {
          // this.$http.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    registerUser () {
      if (!this.checkLogin()) return
      this.$router.push('/pages/register').catch(() => {})
    }
  },
  created () {
    localStorage.removeItem(localStorageKey)
    localStorage.removeItem(tokenExpiryKey)
    localStorage.removeItem('userInfo')
    localStorage.clear()
  }
}

</script>

